// docs: https://github.com/altostra/type-validations#readme
import { objectOf /*, maybe */ } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isAppsGetDefaultCustomPagesAppGroupIdResult = objectOf({
  unsubscribe_page: string,
  opt_in_page: string,
  footer: string,
});
